import { render, staticRenderFns } from "./PermissaoCadastrar.vue?vue&type=template&id=403957fc&"
import script from "./PermissaoCadastrar.vue?vue&type=script&lang=js&"
export * from "./PermissaoCadastrar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports